import { render } from "./CorporateDashboard.vue?vue&type=template&id=50d4ba6e&scoped=true"
import script from "./CorporateDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateDashboard.vue?vue&type=script&lang=js"

import "./CorporateDashboard.vue?vue&type=style&index=0&id=50d4ba6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d4ba6e"]])

export default __exports__